<div id="todo" class="page-layout carded left-sidebar">
    <!-- SIDEBAR -->
    <div class="content inner-scroll" style="overflow: auto; -webkit-overflow-scrolling: touch; width: 230px; height: 100%;">

        <div class="nav material2">
            <mat-calendar [selected]="viewDate" (selectedChange)="changeDate($event);"></mat-calendar>
        </div>

        <div class="nav material2">
            <table class="calendar-users">
                <tr>
                    <td colspan="3">
                        <button (click)="displayInvisible()" mat-raised-button class="mr-8" color="accent">{{'Display invisible'|translate}}</button>
                    </td>
                </tr>
                <tr *ngFor="let user of users" class="{{!user.visible && user.events.length>0?'highlighted-user':''}}">
                    <td>
                        <input type="checkbox" (change)="checkUser($event)" value="{{user.id}}" checked="{{user.visible?'checked':''}}">
                    </td>
                    <td>
                        {{ user.name }}
                    </td>
                    <td>
                        ({{user.events.length}})
                    </td>
                    <!--                        <td>-->
                    <!--                            c-->
                    <!--                        </td>-->
                </tr>
            </table>
        </div>

    </div>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center" style="margin-left: 5px;">

        <div class="content-card scroll-container" style="overflow: hidden; -webkit-overflow-scrolling: touch;" #scrollContainer>

            <div class="row">
<!--                <div class="col-md-6">-->
<!--                    <div class="btn-group">-->
<!--                        <div-->
<!--                                class="btn btn-primary"-->
<!--                                mwlCalendarPreviousView-->
<!--                                [view]="'day'"-->
<!--                                [(viewDate)]="viewDate"-->
<!--                        >-->
<!--                            Previous-->
<!--                        </div>-->
<!--                        <div-->
<!--                                class="btn btn-outline-secondary"-->
<!--                                mwlCalendarToday-->
<!--                                [(viewDate)]="viewDate"-->
<!--                        >-->
<!--                            Today-->
<!--                        </div>-->
<!--                        <div-->
<!--                                class="btn btn-primary"-->
<!--                                mwlCalendarNextView-->
<!--                                [view]="'day'"-->
<!--                                [(viewDate)]="viewDate"-->
<!--                        >-->
<!--                            Next-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="col-md-6 text-left">
                    <div *ngIf="processing"> {{'Processing'|translate}}... </div>
                    <div *ngIf="error.length>0" style="color:red;">
                        <b>{{error|translate}}</b>
                    </div>
                </div>
                <div class="col-md-6 text-right">
                    <h3>{{ viewDate | calendarDate:('dayViewTitle'):locale }}</h3>
                </div>
            </div>

            <mwl-day-view-scheduler
                    [viewDate]="viewDate"
                    [events]="events"
                    [users]="users"
                    [dayStartHour]="7"
                    [dayEndHour]="22"
                    [hourSegments]="6"
                    [weekStartsOn]="weekStartsOn"
                    (eventTimesChanged)="eventTimesChanged($event)"
                    (userChanged)="userChanged($event)"
                    (userClicked)="userClicked($event)"
                    (hourSegmentClicked)="hourClicked($event)"
                    (hourSegmentMouseMove)="startDragToCreate($event)"
                    (eventClicked)="eventClicked($event)"
                    [locale]="locale"
            >
            </mwl-day-view-scheduler>
        </div>

</div>
</div>
